export const EDIT_WINDOW_HOURS = 24;
export const STAGES = ["New Lead", "Sample Sent", "Negotiation", "Won", "Lost"];
export const STAGE_COLORS = {
  "New Lead": "bg-[#EBEBE3] text-neutral-800 border-neutral-300",
  "Sample Sent": "bg-[#D4E1F9] text-blue-900 border-blue-200",
  "Negotiation": "bg-[#FCE4D6] text-orange-900 border-orange-200",
  "Won": "bg-[#C8E6C9] text-green-900 border-green-300",
  "Lost": "bg-[#FFCDD2] text-red-900 border-red-200",
};

// Unit Head is a monitoring account: it sees everything but writes nothing
// (lead comments are the one exception, handled in the Grab A Deal page).
export const isViewer = (user) => user?.role === "unit_head";
export const canWrite = (user) => !!user && !isViewer(user);
export const ROLE_LABEL = { manager: "Manager", staff: "Sales Staff", unit_head: "Unit Head" };

export function canEdit(user, record) {
  if (!user || !record) return false;
  if (isViewer(user)) return false;
  if (user.role === "manager") return true;
  if (record.created_by !== user.id) return false;
  const created = new Date(record.created_at);
  return (Date.now() - created.getTime()) < EDIT_WINDOW_HOURS * 3600 * 1000;
}

// Stage progression bypasses the 24h edit window. Owners can always move
// their own deals through the pipeline; managers can move any deal.
export function canChangeStage(user, record) {
  if (!user || !record) return false;
  if (isViewer(user)) return false;
  if (user.role === "manager") return true;
  return record.created_by === user.id;
}

// ---------- Follow-up date helpers ----------
// ISO YYYY-MM-DD for today (local timezone) — used for <input type="date" min={todayIso()}>.
export function todayIso() {
  const d = new Date();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${m}-${day}`;
}

// Classify a deal's follow_up_date relative to today. Only meaningful for
// deals whose stage is neither Won nor Lost.
export function followUpStatus(deal) {
  if (!deal || !deal.follow_up_date) return null;
  if (["Won", "Lost"].includes(deal.stage)) return null;
  const day = new Date(deal.follow_up_date);
  if (Number.isNaN(day.getTime())) return null;
  const dayIso = day.toISOString().slice(0, 10);
  const nowIso = todayIso();
  if (dayIso < nowIso) return "overdue";
  if (dayIso === nowIso) return "today";
  return null; // future — nothing to badge
}

export function timeLeft(record) {
  const created = new Date(record.created_at).getTime();
  const ms = created + EDIT_WINDOW_HOURS * 3600 * 1000 - Date.now();
  if (ms <= 0) return null;
  const h = Math.floor(ms / 3600000);
  const m = Math.floor((ms % 3600000) / 60000);
  return `${h}h ${m}m left`;
}

export function fmtDate(s) {
  if (!s) return "—";
  return new Date(s).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
}

export const STAGE_TERMINAL = new Set(["Won", "Lost"]);
export function stageAgeDays(deal) {
  if (!deal || STAGE_TERMINAL.has(deal.stage)) return null;
  const ref = deal.stage_changed_at || deal.created_at;
  if (!ref) return null;
  return Math.max(0, Math.floor((Date.now() - new Date(ref).getTime()) / 86400000));
}
export function agingLevel(days) {
  if (days == null) return null;
  if (days >= 30) return "critical"; // red
  if (days >= 14) return "warning";  // orange
  return null;
}
